import constants from '#packages/constants';
import type { CompRef, DocumentServicesObject } from 'types/documentServices';

export const getDesktopRefById = (
  documentServices: DocumentServicesObject,
  id: string,
): CompRef => {
  const compRef = documentServices.components.get.byId(id);

  // compRef could be null in perPage migration flow when non-migrated page opens from mobile view and page has hidden on mobile components
  if (!compRef) {
    return {
      id,
      type: documentServices.viewMode.VIEW_MODES.DESKTOP,
    } as CompRef;
  }

  if (compRef.type !== documentServices.viewMode.VIEW_MODES.DESKTOP) {
    return {
      ...compRef,
      type: documentServices.viewMode.VIEW_MODES.DESKTOP,
    } as CompRef;
  }

  return compRef;
};

export const isAnchor = (
  documentServices: DocumentServicesObject,
  compRef: CompRef,
): boolean =>
  documentServices.components.getType(compRef) === constants.COMP_TYPES.ANCHOR;

export const isSection = (
  documentServices: DocumentServicesObject,
  compRef: CompRef,
): boolean =>
  documentServices.components.getType(compRef) === constants.COMP_TYPES.SECTION;

export const isStrip = (
  documentServices: DocumentServicesObject,
  compRef: CompRef,
): boolean =>
  documentServices.components.getType(compRef) ===
  constants.COMP_TYPES.STRIP_COLUMNS_CONTAINER;

export const isAppController = (
  documentServices: DocumentServicesObject,
  compRef: CompRef,
): boolean =>
  documentServices.components.getType(compRef) ===
  constants.COMP_TYPES.APP_CONTROLLER;
